/**
 * Set map center depending on screen resolution
 *
 * @returns Array
 */
function getMapCenter() {
    if (window.matchMedia('(min-width: 992px)').matches) {
        return [48.65, 9.55];
    }

    return [48.661709, 9.00354];
}

/**
 * Set minimal zoom depending on screen resolution
 *
 * @returns Number
 */
function getMinZoom() {
    if (window.matchMedia('(min-width: 768px').matches) {
        return 8;
    } else {
        return 7;
    }
}

// https://leafletjs.com/reference-1.7.1.html#map-option
export const mapOptions = {
    center: getMapCenter(),
    minZoom: getMinZoom(),
    maxZoom: 13,
    zoom: getMinZoom(),
};

/**
 * Zoom level at which permanent tooltips are visible
 */
export const zoomThreshold = 12;
